import PropTypes from 'prop-types';
import React, { useMemo, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { Card, CardBody, Container, Button, Form, FormGroup, Label, Input, Row, Col } from 'reactstrap';
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { Formik, Field, ErrorMessage, useFormik } from 'formik';
import * as Yup from 'yup';
import TableContainer from 'components/Common/TableContainer';
import { json, Link } from 'react-router-dom';
import { getCurrentCallBoardStatusAPIURL } from 'BaseComponentAPI/CurrentCallBoardStatusAPI';
import { useSelector } from 'react-redux';
import axios from 'axios';
import Spinners from 'components/Common/Spinner';
import PopupWindow from 'components/Common/PopupWindow';
import Loader from 'components/Common/Loader';
import * as XLSX from 'xlsx';  // Import the xlsx library
import { checkPermissions } from 'components/Common/ChkPermissions';

const CurrentCallBoardStatus = (props) => {
    const authUser = useSelector(state => state.Login);
    document.title = "Cockpit";


    const storedPermissions = JSON.parse(localStorage.getItem('permissions')) || {};
    const { canRead, canCreate, canChange } = checkPermissions(storedPermissions);


    const [loaderOption, setLoaderOption] = useState(false);
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [popupMessage, setPopupMessage] = useState('');  // Set the message from passed state
    const [popupType, setPopupType] = useState('');  // Set the type from passed state

    const openPopup = (message, type) => {
        setPopupMessage(message);
        setPopupType(type);
        setIsPopupVisible(true);
    };

    const closePopup = () => {
        setIsPopupVisible(false);
    };

    const columns = useMemo(
        () => [
            {
                header: "Sr No",
                accessorKey: "seqNo",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Call Type",
                accessorKey: "callType",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Call Status",
                accessorKey: "callStatus",
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({ cell }) => (cell.getValue() === 1 ? "Attended" : "Unattened"),
            },
            {
                header: "Customer Name",
                accessorKey: "customerName",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Mobile Number",
                accessorKey: "customerMobile",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Call Time",
                accessorKey: "callReceivedTime",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Header",
                accessorKey: "header",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Verification Starts At",
                accessorKey: "verifierStartsAt",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Disposition",
                accessorKey: "disposition",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Verifier Call End Time",
                accessorKey: "verifierEndAt",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Product",
                accessorKey: "product",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Subcategory",
                accessorKey: "subCategory",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Category",
                accessorKey: "category",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "TC Call Time ",
                accessorKey: "tcCallAt ",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "TC Name",
                accessorKey: "tcName",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Future Header",
                accessorKey: "futureHeader",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Tc Call End Time",
                accessorKey: "tcCallendAt",
                enableColumnFilter: false,
                enableSorting: true,
            },

            //   {
            //     header: "Action",
            //     enableColumnFilter: false,
            //     enableSorting: true,
            //     cell: cellProps => {
            //       return (
            //         <ul className="list-unstyled hstack gap-1 mb-0">
            //           <li data-bs-toggle="tooltip" data-bs-placement="top" title="View">
            //             <Link
            //               to="/job-details"
            //               className="btn btn-sm btn-soft-primary"
            //               id={`viewtooltip-${cellProps.row.original.id}`}
            //             >
            //               <i className="mdi mdi-eye-outline" />
            //             </Link>
            //           </li>
            //           <UncontrolledTooltip
            //             placement="top"
            //             target={`viewtooltip-${cellProps.row.original.id}`}
            //           >
            //             View
            //           </UncontrolledTooltip>

            //           <li>
            //             <Link
            //               to="/createoredituser"
            //               className="btn btn-sm btn-soft-info"
            //             >
            //               <i className="mdi mdi-pencil-outline" />
            //             </Link>
            //           </li>

            //           <li>
            //             <Link
            //               to="#"
            //               className="btn btn-sm btn-soft-danger"
            //               onClick={() => {
            //                 const jobData = cellProps.row.original
            //                 onClickDelete(jobData)
            //               }}
            //               id={`deletetooltip-${cellProps.row.original.id}`}
            //             >
            //               <i className="mdi mdi-delete-outline" />
            //               <UncontrolledTooltip
            //                 placement="top"
            //                 target={`deletetooltip-${cellProps.row.original.id}`}
            //               >
            //                 Delete
            //               </UncontrolledTooltip>
            //             </Link>
            //           </li>
            //         </ul>
            //       )
            //     },
            //   },
        ],
        []
    )

    const [data, setData] = useState([]);
    const [submittedCallType, setSubmittedCallType] = useState("");
    const [pageNo, setPageNo] = useState(1);  // Track the current page number
    const [pageSize, setPageSize] = useState(10);  // Track page size
    const [totalPages, setTotalPages] = useState('');
    const [totalItems, setTotalItems] = useState('');
    const [nextPage, setNextPage] = useState('');
    const [previousPage, setPreviousPage] = useState('');
    const [currentPage, setCurrentPage] = useState('');
    const [disabelSaveBtn, setDisableSaveBtn] = useState(false);

    const handlePageChange = async (newPageNo, newPageSize) => {
        if (formik.values.callType) {
            if (authUser.headers && Object.keys(authUser.headers).length > 0) {
                // console.log(`API URL: ${getCurrentCallBoardStatusAPIURL}?userUUID=${authUser.headers.userUUID}&callType=${formik.values.callType}&pageNo=${newPageNo}&perPageRec=${newPageSize}`);

                try {
                    const response = await axios.get(
                        `${getCurrentCallBoardStatusAPIURL}?userUUID=${authUser.headers.userUUID}&callType=${formik.values.callType}&isPagination=1&pageNo=${newPageNo}&perPageRec=${newPageSize}`,
                        {
                            headers: { ...authUser.headers },
                        }
                    );

                    if (response.data.responseMsg == "Success") {
                        // console.log(JSON.stringify(response.data))
                        setData(response.data.data.items);
                        setTotalPages(response.data.data.totalPages)
                        setTotalItems(response.data.data.totalItems);
                        setNextPage(response.data.data.nextPage);
                        setPreviousPage(response.data.data.previousPage);
                        setCurrentPage(response.data.data.currentPage);
                        setDisableSaveBtn(false);
                        setLoaderOption(false);
                    } else {
                        console.error('API Response Error:', response.data.responseMsg);
                        setLoaderOption(false);
                        setDisableSaveBtn(false);
                        openPopup('Something went wrong!', 'error')

                    }
                } catch (error) {
                    console.error('Error fetching data:', error);
                    setLoaderOption(false);
                    setDisableSaveBtn(false);
                    openPopup('Something went wrong!', 'error')

                }
                // finally {
                //     setLoaderOption(false);
                // }
            }
        }
    };

    const formik = useFormik({
        initialValues: {
            callType: ''
        },
        validationSchema: Yup.object({
            callType: Yup.string()
                .required('Call Type is required'),
        }),

        onSubmit: async (values) => {
            setLoaderOption(true);
            setDisableSaveBtn(true);
            setData([]);
            setTotalPages('');
            // Store the submitted call type for display in the heading
            const callTypeLabelMap = {
                "0": "All",
                "1": "Live",
                "2": "System",
                "3": "Cold",
            };
            setSubmittedCallType(callTypeLabelMap[values.callType]);

            if (authUser.headers && Object.keys(authUser.headers).length > 0) {
                // console.log(`API URL: ${getCurrentCallBoardStatusAPIURL}?userUUID=${authUser.headers.userUUID}&callType=${values.callType}&pageNo=${pageNo}&perPageRec=${pageSize}`);

                try {
                    const response = await axios.get(
                        `${getCurrentCallBoardStatusAPIURL}?userUUID=${authUser.headers.userUUID}&callType=${values.callType}&isPagination=1&pageNo=${pageNo}&perPageRec=${pageSize}`,
                        {
                            headers: { ...authUser.headers },
                        }
                    );

                    if (response.data.responseMsg == "Success") {
                        // console.log(JSON.stringify(response.data))
                        setData(response.data.data.items);
                        setTotalPages(response.data.data.totalPages)
                        setTotalItems(response.data.data.totalItems);
                        setNextPage(response.data.data.nextPage);
                        setPreviousPage(response.data.data.previousPage);
                        setCurrentPage(response.data.data.currentPage);
                        setDisableSaveBtn(false);
                        setLoaderOption(false);
                    } else {
                        console.error('API Response Error:', response.data.responseMsg);
                        setLoaderOption(false);
                        setDisableSaveBtn(false);
                        openPopup('Something went wrong!', 'error')

                    }
                } catch (error) {
                    console.error('Error fetching data:', error);
                    setLoaderOption(false);
                    setDisableSaveBtn(false);
                    openPopup('Something went wrong!', 'error')

                }
                // finally {
                //     setLoaderOption(false);
                // }
            }

        },
    });

    const exportToExcel = () => {
        setLoaderOption(true);
        const ws = XLSX.utils.json_to_sheet(data);  // Convert data to worksheet
        const wb = XLSX.utils.book_new();  // Create a new workbook
        XLSX.utils.book_append_sheet(wb, ws, 'Verifier Data');  // Append the worksheet to the workbook

        // Get the current date and time in IST
        const currentDate = new Date().toLocaleString("en-IN", { timeZone: "Asia/Kolkata" });

        // Format the date as per your requirement
        const formattedDate = currentDate
            .replace(",", "")  // Remove the comma
            .split(" ")        // Split by space to separate date and time
            .map((part, index) => {
                if (index === 0) {
                    // Format date as yyyy/mm/dd
                    return part.split("/").join("/");  // Keeping the format as yyyy/mm/dd
                }
                return part; // Return the time part unchanged
            })
            .join("-");  // Join date and time with a dash

        // Set the file name with Current Calling Status + date & time
        const fileName = `${submittedCallType}-${formattedDate}.xlsx`;

        // Trigger the download with the formatted file name
        XLSX.writeFile(wb, fileName);  // Trigger the download with the formatted file name

        setLoaderOption(false);
    };



    if (loaderOption == true) {
        return (
            <>
                <Loader />
            </>
        )
    }
    else {
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Report" breadcrumbItem="Current Call Board Status" />
                        <Card>
                            <CardBody>

                                <Form onSubmit={formik.handleSubmit}>

                                    <Row>
                                        <Col md={4}>
                                            <FormGroup>
                                                <Label for="callType">Call Type</Label>
                                                <Input
                                                    type="select"
                                                    name="callType"
                                                    id="callType"
                                                    onChange={(e) => {
                                                        formik.handleChange(e);
                                                        setData([]); // Reset the data when the call type changes
                                                    }}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.callType}
                                                >
                                                    <option value="">Select Call Type</option>
                                                    <option value={0}>All</option>
                                                    <option value={1}>Live</option>
                                                    <option value={2}>System</option>
                                                    <option value={3}>Cold</option>
                                                </Input>
                                                {formik.touched.callType && formik.errors.callType ? (
                                                    <div style={{ color: 'red', marginTop: '5px' }}>
                                                        {formik.errors.callType}
                                                    </div>
                                                ) : null}
                                            </FormGroup>
                                        </Col>
                                    </Row>


                                    <Button color="primary" type="submit" disabled={disabelSaveBtn || !canRead}>
                                        Submit
                                    </Button>
                                </Form>

                                {(data.length != 0)
                                    ?
                                    <>
                                        <h5 className="mt-4" style={{ color: '#b72323' }}>
                                            Report for : Current {submittedCallType} Call Status
                                        </h5>

                                        <div className='mt-3'>
                                            <div className="d-flex align-items-center justify-content-end">
                                                <div className="flex-shrink-0">
                                                    <button
                                                        onClick={exportToExcel}  // Trigger the export function
                                                        className="btn btn-primary me-1"
                                                    >
                                                        Export Excel
                                                    </button>
                                                </div>
                                            </div>
                                            <TableContainer
                                                columns={columns}
                                                data={data || []}
                                                isGlobalFilter={true}
                                                isPagination={true}
                                                SearchPlaceholder="Search..."
                                                isCustomPageSize={true}
                                                tableClass="align-middle table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                                                theadClass="table-light"
                                                paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                                pagination="pagination"
                                                getRowProps={row => ({
                                                    className: `${row.original.callStatus === 0 ? "is-receivable" : ""
                                                        }`,
                                                })}
                                                onPageChange={handlePageChange} // Pass page change handler
                                                onPageSizeChange={handlePageChange} // Pass page size change handler
                                                pageSize={pageSize}
                                                setPageSize={setPageSize}
                                                totalPages={totalPages}
                                                totalItems={totalItems}
                                                tableNextPage={nextPage}
                                                tablePreviousPage={previousPage}
                                                tableCurrentPage={currentPage}

                                            />
                                        </div>
                                    </>
                                    :
                                    ''
                                }



                            </CardBody>
                        </Card>
                    </Container>
                </div>

                {isPopupVisible && (
                    <PopupWindow message={popupMessage} type={popupType} onClose={closePopup} />
                )}
            </React.Fragment >
        );
    }


};

CurrentCallBoardStatus.propTypes = {
    t: PropTypes.any,
};

export default withTranslation()(CurrentCallBoardStatus);
